"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide6 = exports.HomepageSlide6 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
class HomepageSlide6 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      :host {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 1rem;
        width: 100%;
        max-width: var(--slide-max-width, 100%);
        margin: 5rem auto;
        box-sizing: border-box;
        font-size: 2.4rem;
        
        font-family: 'quaaykop-medium', sans-serif;
        
        view-timeline-name: --slide-timeline;
        view-timeline-axis: block;
      }
      
      @keyframes animate-column {
        from { transform: translateX(-200%); }
        to { transform: translateX(0); }      
      }
      
      div.column-1 {
        animation: animate-column linear;
        animation-timeline: --slide-timeline;
        animation-range: entry 60% entry 90%;
        animation-fill-mode: both;
      }
      
      div.column-2 {
        animation: animate-column linear;
        animation-timeline: --slide-timeline;
        animation-range: entry 30% entry 60%;
        animation-fill-mode: both;
      }
      
      div.column-2 video {
        width: 100%;
        object-fit: cover;
        aspect-ratio: 1.975 / 1;
      }
      
      img {
        width: 100%;
      }
      
      span.premium-grade {
        white-space: nowrap;
      }
      
      div.column-1 div.content, div.column-2 div.content {
        margin-top: 1rem;
      }
      
      @media (max-width: 600px) {
        :host {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 1rem;
          box-sizing: border-box;
          margin: 1rem auto;
          
          font-size: 1.3rem;
        }
        
        div.column-1 {
          animation-range: entry 30% entry 60%;
        }
        
        div.column-2 {
          animation-range: entry 60% entry 90%;
        }
      }
    </style>
    <div class="column-1">
      <img src="/files/assets/images/slide-6-cell-1.jpg" />
      <div class="content">
        AiLEENE always places Quality Above everything else.
      </div>
    </div>
    <div class="column-2">
      <video autoplay muted loop playsinline>
        <source src="/files/assets/videos/slide-6-premium-ingredients.mp4">
      </video>
      <div class="content">
        AiLEENE always uses only the finest, <span class="premium-grade">premium-grade</span> ingredients.
      </div>
    </div>`;
    }
}
exports.HomepageSlide6 = HomepageSlide6;
const defineHomepageSlide6 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide6);
};
exports.defineHomepageSlide6 = defineHomepageSlide6;
